import { render, staticRenderFns } from "./Work_statistics.vue?vue&type=template&id=7d81ecb0"
import script from "./Work_statistics.vue?vue&type=script&lang=js"
export * from "./Work_statistics.vue?vue&type=script&lang=js"
import style0 from "./Work_statistics.vue?vue&type=style&index=0&id=7d81ecb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports